import { subclass } from "esri/core/accessorSupport/decorators";
import { tsx } from "esri/widgets/support/widget";
import Widget = require("esri/widgets/Widget");
import * as geometryEngine from "esri/geometry/geometryEngine"
import { returnSearchParams, clearGraphicType, urbanAreasNames, mpoNames, countyNames, districtNames, titleCase, autocomplete, returnSearchParamsFromLayer } from "./App/setupView";
import * as boundaryLayers from "../data/Layers/boundaryLayers";
import watchUtils = require("esri/core/watchUtils");
import Query = require("esri/rest/support/Query");
import HorizontalSlider = require("dijit/form/HorizontalSlider");
import MapImageLayer = require("esri/layers/MapImageLayer");
import FeatureLayer = require("esri/layers/FeatureLayer");
import Graphic = require("esri/Graphic");
import MapView = require("esri/views/MapView");
import SimpleFillSymbol = require("esri/symbols/SimpleFillSymbol");
import Polygon = require("esri/geometry/Polygon");
import Geometry = require("esri/geometry/Geometry");
import webMercatorUtils = require("esri/geometry/support/webMercatorUtils");

const CSS = {
  base: "mask-widget"
};

let maskSymbol: SimpleFillSymbol;
let maskGraphic: Graphic;
let bufferSize: number;
let bufferSlider: any;

@subclass("esri.widgets.Mask")
class Mask extends Widget {
  curLayer:MapImageLayer = boundaryLayers.illinoisCounties;
  searchText = "";
  illinoisBoundary: Polygon;
  view: MapView;

  constructor(viewIn: MapView) {
    super();
    this.view = viewIn;
    this._createIllnoisMask();
  }

  // -------------------------------------------------------------------
  //
  //  Public methods
  //
  // -------------------------------------------------------------------

  render() {
    return (
      <div class={CSS.base}>
        <h3>Mask It!</h3>
        <select class="mask-select" id="selectMaskList" bind={this} onchange={this._maskSelectChange}>
          <option value="County">County</option>
          <option value="District">District</option>
          <option value="Township">Township</option>
          <option value="UrbanArea">Urban Area</option>
          <option value="MPOArea">MPO Area</option>
          <option value="Town">Town</option>
        </select>
        <select
          class="mask-select"
          id="selectMPOmask"
          style="width:150px; display:none"
          bind={this}
          onchange={this._selectMPOChange}
        >
          {mpoNames.map(item => {
            return (
              <option key={item.index} value={item.id}>
                {item.name}
              </option>
            );
          })}
        </select>
        <select
          class="mask-select"
          id="selectUrbanAreasmask"
          style="width:150px; display:none"
          bind={this}
          onchange={this._selectUrbanAreasChange}
        >
          {urbanAreasNames.map(item => {
            return (
              <option key={item.index} value={item.id}>
                {item.name}
              </option>
            );
          })}
        </select>
        <select
          class="mask-select"
          id="selectDistrictsmask"
          style="width:150px; display:none"
          bind={this}
          onchange={this._selectDistrictsChange}
        >
          {districtNames.map(item => {
            return (
              <option key={item.index} value={item.id}>
                {item.name}
              </option>
            );
          })}
        </select>
        <select
          class="mask-select"
          id="selectCountiesmask"
          style="width:150px; display:none"
          bind={this}
          onchange={this._selectCountiesChange}
        >
          {countyNames.map(item => {
            return (
              <option key={item.index} value={item.id}>
                {item.name}
              </option>
            );
          })}
        </select>
        <p
          style="margin-left:10px; margin-right:10px; margin-top:5px; margin-bottom:5px; font-size:small"
          id="maskPrompt"
        />
        <div class="autocomplete" id="showTownship" style="width:150px; display:none">
          <input
            autocomplete="off"
            type="text"
            class="mask-text"
            id="selectTownship"
            style="width:150px"
            bind={this}
            oninput={this._selectTownshipChange}
          />
        </div>
        <div class="autocomplete" id="showTowns" style="width:150px; display:none">
          <input
            type="text"
            class="mask-text"
            id="selectTowns"
            autocomplete="off"
            style="width:150px"
            bind={this}
            oninput={this._selectTownsChange}
          />
        </div>
        <input
          type="text"
          class="mask-text"
          name="maskText"
          id="maskText"
          bind={this}
          oninput={this._maskTextChange}
          onkeyup={this._maskTextKeyup}
        />
        <br />
        <div id="opacitySlider" />
        <p style="margin-left:93px; margin-top:5px" id="opacitySliderValue">
          Opacity : 80
        </p>
        <div id="bufferSlider" />
        <p style="margin-left:73px" id="bufferSliderValue2">
          Buffer :{" "}
          <input
            type="number"
            min="0"
            max="2000"
            class="mask-buffer-text"
            name="bufferText"
            id="bufferSliderValue"
            bind={this}
            oninput={this._maskBufferChange}
          />{" "}
          ft
        </p>
        <input
          type="button"
          class="mask-button"
          value="Clear Mask"
          id="btnClearMask"
          bind={this}
          onclick={this._maskBtn}
        />
        <input type="button" class="mask-button" value="Mask It" id="btnMaskIt" bind={this} onclick={this._maskBtn} />
        <p style="margin-left:95px; margin-top:5px; color:red" id="message" />
      </div>
    );
  }

  _opacitySliderChange(value: any) {
    const sliderText = document.getElementById("opacitySliderValue");
    if (sliderText) {
      sliderText.innerText = "Opacity : " + value.toFixed(0);
      const opacity: number = value / 100;
      maskSymbol = new SimpleFillSymbol({
        color: [255, 255, 255, opacity],
        style: "solid",

        outline: {
          color: [0, 0, 0],
          width: 0
        }
      });
      if (maskGraphic) {
        maskGraphic.symbol = maskSymbol;
      }
    }
  }

  _bufferSliderChange(value: any) {
    const sliderText = document.getElementById("bufferSliderValue") as HTMLInputElement;
    if (sliderText) {
      sliderText.value = isNaN(value) ? 0 : value.toFixed(0);
      bufferSize = value;
      if (maskGraphic) {
        maskGraphic.symbol = maskSymbol;
      }
    }
  }

  init() {
    // console.log("Mask init()");

    const opacitySliderExist = document.getElementById("opacitySlider");
    if (!opacitySliderExist || !opacitySliderExist.childNodes || opacitySliderExist.childNodes.length === 0) {
      new HorizontalSlider(
        {
          name: "opacitySlider",
          value: 80,
          minimum: 0,
          maximum: 100,
          intermediateChanges: true,
          style: "width:200px;margin-left:20px",
          onChange: this._opacitySliderChange
        },
        "opacitySlider"
      ).startup();
      // console.log("Slider = ", this.slider);
      this._opacitySliderChange(80);

    }

    const bufferSliderExist = document.getElementById("bufferSlider");
    if (!bufferSliderExist || !bufferSliderExist.childNodes || bufferSliderExist.childNodes.length === 0) {
      bufferSlider = new HorizontalSlider(
        {
          name: "bufferSlider",
          value: 1000,
          minimum: 0,
          maximum: 2000,
          intermediateChanges: true,
          style: "width:200px;margin-left:20px;margin-top:10px",
          onChange: this._bufferSliderChange
        },
        "bufferSlider"
      );
      bufferSlider.startup();
      // console.log("Slider = ", this.slider);
      this._bufferSliderChange(1000);
      this._maskSelectChange();
    }
  }

  _createIllnoisMask() {
    // console.log("createIllinoisMask");
    this.illinoisBoundary = new Polygon({
      hasZ: false,
      hasM: false,
      rings: [[[-105, 25], [-105, 55], [-70, 55], [-70, 25], [-105, 25]]], // Big box around Illinois
      spatialReference: { wkid: 4326 }
    });

    // this.illinoisBoundary = webMercatorUtils.geographicToWebMercator(this.illinoisBoundary) as Polygon;

    // const query = new Query({
    //   where: "1=1",
    //   returnGeometry: true
    // });

    // const sublayer = (boundaryLayers.idotDistrictsLayer as MapImageLayer).sublayers.getItemAt(0);
    // sublayer
    //   .queryFeatures(query)
    //   .then(results => {
    //     if (results && results.features && results.features.length > 0) {
    //       this.illinoisBoundary = geometryEngine.union(results.features.map((value, index) => value.geometry)) as Polygon;
    //       this.maskGraphic = new Graphic({
    //         geometry: this.illinoisBoundary,
    //         attributes: { type: "selected" },
    //         symbol: this.maskSymbol
    //       });
    //     }
    //   })
    //   .catch(errorCallback);
  }

  private _maskTextKeyup(event: KeyboardEvent) {
    // console.log("keyup ", event);
    if (event.key === "Enter") {
      this._maskIt();
    }
  }

  private _maskTextChange(event: MouseEvent) {
    // console.log("Button press", event);
    if (event.srcElement) {
      const input = event.srcElement as HTMLInputElement;
      // console.log(" Mask Text = ", input.value);
      this.searchText = input.value;
    }
  }

  private _maskBufferChange(event: MouseEvent) {
    // console.log("Button press", event);
    if (event.srcElement) {
      const input = event.srcElement as HTMLInputElement;
      // console.log(" Mask Text = ", input.value);
      bufferSlider.set("value", parseInt(!input.value || input.value === "" ? "0" : input.value, 10));
    }
  }

  private _selectMPOChange(event?: MouseEvent) {
    if (event && event.srcElement) {
      const input = event.srcElement as HTMLSelectElement;
      this.searchText = input.value;
    }
  }

  private _selectUrbanAreasChange(event?: MouseEvent) {
    if (event && event.srcElement) {
      const input = event.srcElement as HTMLSelectElement;
      this.searchText = input.value;
    }
  }

  private _selectTownsChange(event: MouseEvent) {
    if (event.srcElement) {
      const input = event.srcElement as HTMLInputElement;
      this.searchText = input.value;
      this._queryTownsSuggestions(this.searchText);
    }
  }

  private _selectTownshipChange(event: MouseEvent) {
    if (event.srcElement) {
      const input = event.srcElement as HTMLInputElement;
      this.searchText = input.value;
      this._queryTownshipSuggestions(this.searchText);
    }
  }

  private _selectCountiesChange(event?: MouseEvent) {
    if (event && event.srcElement) {
      const input = event.srcElement as HTMLSelectElement;
      this.searchText = input.value;
    }
  }

  private _selectDistrictsChange(event?: MouseEvent) {
    if (event && event.srcElement) {
      const input = event.srcElement as HTMLSelectElement;
      this.searchText = input.value;
    }
  }

  private _queryTownsSuggestions(town:string) {
    if (town.trim().length >= 2) {

      const queryTowns = new Query({
        outFields: ["IDOT_NAME"],
        orderByFields: ["IDOT_NAME"],
        where: "lower(IDOT_NAME) LIKE lower('" + town.trim() + "%')",
        returnDistinctValues: true,
        returnGeometry: false
      });

      const sublayer = this.curLayer.sublayers.getItemAt(0);
      sublayer
        .queryFeatures(queryTowns)
        .then(results => {
          const towns:string[] = [];
          for (let i=0; i<Math.min(5, results.features.length); i++) {
            if (results.features[i]) {
              towns.push(titleCase(results.features[i].attributes.IDOT_NAME));
            }
          }
          autocomplete(document.getElementById("selectTowns") as HTMLInputElement, towns, titleCase);        
          })
        .catch(() => {
          autocomplete(document.getElementById("selectTowns") as HTMLInputElement, []);        
        });
    } else {
      autocomplete(document.getElementById("selectTowns") as HTMLInputElement, []);        
    }
  }

  private _queryTownshipSuggestions(town:string) {
    if (town.trim().length >= 2) {

      const queryTowns = new Query({
        outFields: ["NAME"],
        orderByFields: ["NAME"],
        where: "lower(NAME) LIKE lower('" + town.trim() + "%')",
        returnDistinctValues: true,
        returnGeometry: false
      });

      const sublayer = this.curLayer.sublayers.getItemAt(0);
      sublayer
        .queryFeatures(queryTowns)
        .then(results => {
          const towns:string[] = [];
          for (let i=0; i<Math.min(5, results.features.length); i++) {
            if (results.features[i]) {
              towns.push(titleCase(results.features[i].attributes.NAME));
            }
          };
          autocomplete(document.getElementById("selectTownship") as HTMLInputElement, towns, titleCase);        
          })
        .catch(() => {
          autocomplete(document.getElementById("selectTownship") as HTMLInputElement, []);        
        });
    } else {
      autocomplete(document.getElementById("selectTownship") as HTMLInputElement, []);        
    }
  }

  private _maskSelectChange(event?: MouseEvent) {
    // console.log("Button press", event);
    if (event && event.srcElement) {
      const select = event.srcElement as HTMLSelectElement;
      this._changeLayer(select.value);
    }

    const prompt = document.getElementById("maskPrompt") as HTMLElement;
    const serachParams = returnSearchParamsFromLayer(this.curLayer);
    const mpoSelect = document.getElementById("selectMPOmask") as HTMLSelectElement;
    const urbanAreasSelect = document.getElementById("selectUrbanAreasmask") as HTMLSelectElement;
    const countiesSelect = document.getElementById("selectCountiesmask") as HTMLSelectElement;
    const districtsSelect = document.getElementById("selectDistrictsmask") as HTMLSelectElement;
    const townsShow = document.getElementById("showTowns") as HTMLDivElement;
    const townshipShow = document.getElementById("showTownship") as HTMLDivElement;
    const townsSelect = document.getElementById("selectTowns") as HTMLInputElement;
    const townshipSelect = document.getElementById("selectTownship") as HTMLInputElement;

    const maskText = document.getElementById("maskText") as HTMLInputElement;

    mpoSelect.style.display = "none";
    urbanAreasSelect.style.display = "none";
    countiesSelect.style.display = "none";
    districtsSelect.style.display = "none";
    townsShow.style.display = "none";
    townshipShow.style.display = "none";

    if (maskText) {
      maskText.style.display = "none";
    }
    if (prompt) {
      prompt.innerText = "";
    }

    if (this.curLayer.id === boundaryLayers.mpoAreasLayer.id) {
      this.searchText = mpoSelect.value;
      mpoSelect.style.display = "block";
    } else if (this.curLayer.id === boundaryLayers.urbanAreasLayer.id) {
      this.searchText = urbanAreasSelect.value;
      urbanAreasSelect.style.display = "block";
    } else if (this.curLayer.id === boundaryLayers.illinoisCounties.id) {
      this.searchText = countiesSelect.value;
      countiesSelect.style.display = "block";
    } else if (this.curLayer.id === boundaryLayers.idotDistrictsLayer.id) {
      this.searchText = districtsSelect.value;
      districtsSelect.style.display = "block";
    } else if (this.curLayer.id === boundaryLayers.illinoisTownsLayer.id) {
      this.searchText = townsSelect.value;
      townsShow.style.display = "block";
    } else if (this.curLayer.id === boundaryLayers.politicalTownshipsLayer.id) {
      this.searchText = townshipSelect.value;
      townshipShow.style.display = "block";
    } else {
      this.searchText = maskText.value;
      if (maskText) {
        maskText.style.display = "block";
        maskText.focus();
      }
      if (prompt) {
        prompt.innerText = serachParams.prompt;
      }
    }
    // console.log("btnName = ", btnName);
  }

  private _changeLayer(selectItem: string) {
    switch (selectItem) {
      case "District":
        this.curLayer = boundaryLayers.idotDistrictsLayer;
        break;

      case "Township":
        this.curLayer = boundaryLayers.politicalTownshipsLayer;
        break;

      case "UrbanArea":
        this.curLayer = boundaryLayers.urbanAreasLayer;
        break;

      case "MPOArea":
        this.curLayer = boundaryLayers.mpoAreasLayer;
        break;

      case "Town":
        this.curLayer = boundaryLayers.illinoisTownsLayer;
        break;

      default:
        // Default to County
        this.curLayer = boundaryLayers.illinoisCounties;
        break;
    }
  }

  private _clearMask() {
    clearGraphicType(this.view, "mask");
    const message = document.getElementById("message");
    if (message) {
      message.innerText = "";
    }
  }

  private _maskBtn(event: MouseEvent) {
    if (event.srcElement) {
      const btnName = (event.srcElement as HTMLElement).id;
      if (btnName === "btnMaskIt") {
        this._maskIt();
      } else if (btnName === "btnClearMask") {
        this._clearMask();
      }
    }
    // console.log("btnName = ", btnName);
  }

  private _createMask(results: __esri.FeatureSet) {
    // console.log("Create mask ", results);
    try {
      this._clearMask();
      if (results && results.features && results.features.length > 0) {
        const graphics = results.features;

        const newPolygon = webMercatorUtils.webMercatorToGeographic(graphics[0].geometry);
        const newBuf = bufferSize === 0 ? newPolygon : geometryEngine.geodesicBuffer(newPolygon, bufferSize, "feet");
        const newGeometry = newBuf instanceof Polygon ? newBuf : newBuf[0];

        if (newGeometry.extent) {
          const maskGeometries = geometryEngine.difference(this.illinoisBoundary, newGeometry);
          const maskGeometry =
            maskGeometries instanceof Geometry ? (maskGeometries as Geometry) : (maskGeometries as Geometry[])[0];

          maskGraphic = new Graphic({
            geometry: maskGeometry,
            attributes: { type: "mask" },
            symbol: maskSymbol
          });
          this.view.goTo(newGeometry.extent.expand(1.5)).then((value) => {
            // console.log("No error in goto");
            watchUtils.whenFalseOnce(this.view, "updating", () => {
              document.body.style.cursor = "default";
              this.view.graphics.add(maskGraphic);
            });  
          });
        }
      } else {
        const message = document.getElementById("message");
        if (message) {
          message.innerText = "Not found !!";
        }
        document.body.style.cursor = "default";
      }
    } catch (error) {
      console.error("Error: in selectRow " + error.message);
      document.body.style.cursor = "default";
    }
  }

  private _maskIt() {

    const serachParams = returnSearchParams(this.curLayer.sublayers.getItemAt(0).id.toString());

    if (serachParams.search !== "") {
      let searchStr = this.searchText;
      if (searchStr) {
        searchStr = searchStr.trim();
        document.body.style.cursor = "wait";

        if (
          serachParams.suffix !== "" &&
          searchStr.toLowerCase().slice(-serachParams.suffix.length) !== serachParams.suffix
        ) {
          searchStr += serachParams.suffix;
        }

        const query = new Query({
          outFields: ["*"],
          where: serachParams.numeric
            ? serachParams.search + " = " + searchStr
            : "lower(" + serachParams.search + ") = lower('" + searchStr + "')",
          returnGeometry: true
        });

        if (this.curLayer instanceof MapImageLayer) {
          const sublayer = (this.curLayer as MapImageLayer).sublayers.getItemAt(0);
          sublayer
            .queryFeatures(query)
            .then(results => {
              this._createMask(results);
            })
            .catch(errorCallback);
        } else if ((this.curLayer as any) instanceof FeatureLayer) {
          const layer = this.curLayer as FeatureLayer;
          layer
            .queryFeatures(query)
            .then(results => {
              this._createMask(results);
            })
            .catch(errorCallback);
        }
      }
    }
  }
}

function errorCallback(error: Error) {
  console.error("error in mask query:", error);
  document.body.style.cursor = "default";
}

export = Mask;
